import React, { useEffect, useState } from 'react';
import MyTypes from 'MyTypes'
import { commonFeatureActions, commonFeatureSelectors } from '../../features/commonfeature';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { withStyles, Button, Paper, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import RefreshIcon from '@material-ui/icons/Refresh';
import MixedBannerDisplay from '../../components/mixedbannerdisplay';
import CampaignBannerDialog from '../../components/mixedbannerdisplay/CampaignBannerDialog';
import { getColumns } from '../../components/mixedbannerdisplay/columns';
import { MixedBanner } from '../../api/models';
import { createMixedBanner, patchMixedBanner } from '../../api/admin';
import { handleApiError } from '../../utils';

const mapStateToProps = (state: MyTypes.RootState) => ({
    data: commonFeatureSelectors.getMixedBannerTaskData(state.commonFeatures)
})

const mapDispatchToProps = (dispatch: Dispatch<MyTypes.RootAction>) => 
    bindActionCreators(
        {

            updateAppBarConfig: commonFeatureActions.updateAppBarConfig,
            getMixedBannerPage: commonFeatureActions.getMixedBannerPage,
            showMessage: commonFeatureActions.showMessage,
        },
        dispatch
    )


const styles = (theme: any) => ({
    container: {
        width: '100%'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120
    }
})

type Props = {
    container: string,
    formControl: String
}

type RealProps = RouteComponentProps & Props & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>



function MixedBannerPage (props: RealProps) {
    const { container, data } = props;

    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [statusFilter] = useState('initial');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogInitial, setDialogInitial] = useState<MixedBanner | null>(null);
    const [dialogKey, setDialogKey] = useState(0);

    useEffect(()=> {
        props.updateAppBarConfig({ title: 'Mixed Banner' })
        
    })

    useEffect(()=> {
        console.log('on page or per Page changed')
        getNext() 
        // getNext is intentionally not a dependency: it is recreated on every
        // render, so depending on it would refetch in a loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, perPage, statusFilter])

    const onCurrentPageChange = (currentPage: number) => {
        console.log('onChange Current Page', currentPage)
        setPage(currentPage);
    }

    const getNext = () => {
        console.log('Client Task get Next', statusFilter)
        const filters: Array<String> = []
        if (statusFilter !== '') {
            filters.push(`status=${statusFilter}`)
        }
        props.getMixedBannerPage({
            page: page + 1,
            perPage: perPage,
            filters
        })
    }

    const onPageSizeChange = (pageSize: number) => {
        setPerPage(pageSize);
    }

    /**
     * TASK-52: tag campaigns are created and edited in this dialog. The write
     * goes straight through the request layer (same endpoints the redux epics
     * call) so the grid can be refreshed deterministically once it has landed.
     */
    const openCampaignDialog = (banner?: MixedBanner | null) => {
        setDialogInitial(banner != null ? banner : null);
        setDialogKey(key => key + 1);
        setDialogOpen(true);
    }

    const closeCampaignDialog = () => {
        setDialogOpen(false);
    }

    const submitCampaignDialog = async (args: any) => {
        const initial = dialogInitial;
        try {
            if (initial != null) {
                await patchMixedBanner(initial.id, args);
                // 'snack' not 'dialog': ops often save several banners in a row
                // and a modal to acknowledge would block the next edit.
                props.showMessage({ message: `Patched Mixed Banner id: ${initial.id}`, type: 'snack' });
            } else {
                await createMixedBanner(args);
                props.showMessage({ message: 'Created Mixed Banner', type: 'snack' });
            }
            closeCampaignDialog();
            getNext();
        } catch (error) {
            handleApiError(error, props.showMessage);
        }
    }

    return (
        
        <div className={container}>
            <Paper>
                <Grid container direction='row' alignItems='center'>
                    <Grid item>
                        <Button
                            style={{margin: '1em'}}
                            onClick={getNext}
                            variant="contained"
                            color="primary"
                        ><RefreshIcon /> Refresh </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            style={{margin: '1em'}}
                            variant="contained"
                            color="secondary"
                            data-testid='create-campaign-banner'
                            onClick={() => openCampaignDialog(null)}
                        >New campaign banner</Button>
                    </Grid>        
                </Grid>
            </Paper>
            
            <MixedBannerDisplay
                header='Mixed Banner'
                columns={getColumns(props.history, true, openCampaignDialog)}
                onTagCampaignRequested={() => openCampaignDialog(null)}
                showAdd
                showEdit
                page={page}
                perPage={perPage}
                onPageSizeChange={onPageSizeChange}
                data={data.cached != null ? data.cached!!.items : Array<MixedBanner>()}
                onCurrentPageChange={onCurrentPageChange}
                totalCount={data.cached != null ? data.cached.total : undefined}
                >
            </MixedBannerDisplay>

            {dialogOpen ?
                <CampaignBannerDialog
                    key={dialogKey}
                    initial={dialogInitial}
                    onClose={closeCampaignDialog}
                    onSubmit={submitCampaignDialog}
                /> : null}
        </div>
    )
}




export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    mapDispatchToProps
)(MixedBannerPage)))
